import { PageModal } from '@dev-spendesk/grapes';
import React, { useEffect } from 'react';

import { type PriceMigrationPlan } from 'modules/company/billing/components/CompanyPlan/hooks/useGetBillingMigration/useGetBillingMigration';
import { AnalyticEventName, track } from 'src/core/utils/analytics';

import { PricingUpdate2025Content } from './PricingUpdateModalContent/2025PricingUpdate';
import { AnnualPricingUpdateContent } from './PricingUpdateModalContent/AnnualPricingUpdate';

type Props = {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  migrationPlan: PriceMigrationPlan;
  userId: string;
};

export const PricingUpdateModal = ({
  isOpen,
  setIsOpen,
  migrationPlan,
  userId,
}: Props) => {
  useEffect(() => {
    if (isOpen) {
      track(AnalyticEventName.PRICE_UPDATE_MODAL_OPENED, { user_id: userId });
    }
  }, [isOpen, userId]);

  const renderContent = () => {
    switch (migrationPlan.type) {
      case 'Annual-Price-Increase':
        return <AnnualPricingUpdateContent migrationPlan={migrationPlan} />;
      case '2025-PricingIncrease-Trial':
        return <PricingUpdate2025Content migrationPlan={migrationPlan} />;
      default:
        throw new Error(`Unknown migrationPlanType ${migrationPlan.type}`);
    }
  };

  return (
    <PageModal
      isOpen={isOpen}
      onClose={() => setIsOpen(false)}
      title={
        <img
          src="/static/img/spendesk-black-logo.svg"
          width={124}
          alt="Spendesk logo"
          className="ml-12"
        />
      }
    >
      {renderContent()}
    </PageModal>
  );
};
